module.exports = __webpack_public_path__ + "static/media/kids_in_sevilla.e58981a1.jpg";